<template>
    <Head title="Travel Goals | Settings" />
    <div class="px-4 md:px-8" data-page="settings">
        <!-- Page header -->
        <div class="sm:flex sm:justify-between sm:items-center mb-10">
            <!-- Left: Title -->
            <div class="mb-4 sm:mb-0">
                <h1 class="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
                    Account Settings
                </h1>
            </div>
        </div>

        <div
            class="lg:bg-white dark:bg-slate-800 dark:lg:bg-slate-800 lg:shadow-lg dark:lg:shadow-slate-900/50 lg:rounded-sm lg:border lg:border-gray-200 dark:lg:border-slate-700 mb-8"
        >
            <div class="flex flex-col lg:flex-row">
                <div
                    class="flex flex-nowrap p-0 lg:px-5 lg:py-10 bg-white dark:bg-slate-800 shadow-lg dark:shadow-slate-900/50 rounded-sm border border-gray-200 dark:border-slate-700 mb-8 lg:border-none lg:shadow-none"
                >
                    <SettingsNav />
                </div>

                <div
                    class="p-5 lg:px-0 lg:py-0 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-gray-200 mb-8 lg:mb-0 lg:border-r-0 lg:border-x-0 lg:border-y-0 lg:!border-l lg:!border-gray-200 lg:shadow-none"
                    style="grow: 1"
                >
                    <div class="flex flex-nowrap flex-col lg:px-10 lg:py-10">
                        <ul v-if="users.length > 1" class="pill-list mb-6">
                            <li
                                v-for="(walletUser, uIndex) in users"
                                :key="'tg-user-' + uIndex"
                            >
                                <a
                                    class="btn-base pill"
                                    href="#"
                                    role="button"
                                    :class="{
                                        dark:
                                            selectedUser?.uuid ===
                                            walletUser.uuid,
                                    }"
                                    @click.prevent="selectUser(walletUser)"
                                >
                                    {{ walletUser.name }}
                                </a>
                            </li>
                        </ul>

                        <TravelGoals
                            v-if="selectedUser"
                            :selectedUser="selectedUser"
                            :key="selectedUser.uuid"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import { ref, onMounted } from 'vue';
import SettingsNav from '@/Pages/Settings/partials/nav.vue';
import TravelGoals from '@/components/user-settings/travel-goals.vue';
import { useDashboardStore } from '@/store/dashboard';
import { storeToRefs } from 'pinia';

const dashboardStore = useDashboardStore();
const { users } = storeToRefs(dashboardStore);
const selectedUser = ref(null);

function selectUser(walletUser) {
    selectedUser.value = walletUser;
}

onMounted(async () => {
    if (!dashboardStore.users.length) {
        await dashboardStore.getUsersOnly();
    }

    if (dashboardStore.users.length > 0) {
        selectedUser.value = dashboardStore.users[0];
    }
});
</script>
